import type { NigerianStateCode } from '@solar/contracts';

import { apiClient } from '../../lib/api-client';

export interface AddressAutocompleteSuggestion {
  readonly displayAddress: string;
  readonly line1: string | null;
  readonly line2: string | null;
  readonly area: string | null;
  readonly city: string | null;
  readonly stateCode: NigerianStateCode | null;
  readonly postalCode: string | null;
  readonly countryCode: 'NG';
  /** Transient display data only; no customer form persists these values. */
  readonly latitude: number | null;
  readonly longitude: number | null;
  readonly provider: 'GEOAPIFY';
  readonly providerPlaceId: string | null;
}

export interface AddressAutocompleteResponse {
  readonly suggestions: readonly AddressAutocompleteSuggestion[];
}

/** The browser only calls Seamontech's authenticated API, never Geoapify. */
export const locationsApi = {
  addressAutocomplete(query: string, signal: AbortSignal): Promise<AddressAutocompleteResponse> {
    return apiClient.post('/customer/locations/address-autocomplete', { query }, { signal });
  },
};
